import { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { PROMPT_NODE_ID } from '../../../../const';

import { useStyles } from './useStyles';

export const InstructionNode = forwardRef(({ element, children, ...attributes }, ref) => {
  const styles = useStyles();
  return (
    <span
      ref={ref}
      className={styles.root}
      id={PROMPT_NODE_ID.instruction}
      {...attributes}
    >
      {children}
    </span>
  );
});

InstructionNode.propTypes = {
  attributes: PropTypes.shape({}),
  element: PropTypes.shape().isRequired,
  children: PropTypes.node,
};

InstructionNode.defaultProps = {
  attributes: {},
  children: null,
};
